// CandidateModal.js
/**
 * PS_CP_01 - PS_CP_04 
 * State variable declarations and import functions
 */
import React from 'react';
import moment from 'moment';

const CandidatePopupGrid = (props) => {
    
    const { candidateRecords, checkArray, setCheckBoxCount, setCheckArray, setallCheck, setHideBar, gridDataStatus, SelectedRadio, arrStatusStore } = props;
    const gridRecord = candidateRecords.flat()
    let convertDate = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };
    /**
     * PS_CP_13 - PS_CP_22
     * Handle the change in the check box ans set the values to through props to the main grid component
     */
    const handleCheckboxChange = (e, index) => {
        const newArray = [...checkArray]; // create a new array
        newArray[index] = !newArray[index]; // update the value at the specified index
        setCheckArray(newArray); // update the checkArray state in the parent component

        if (e.target.checked) {
            candidateRecords[index].isCheck = true

        } else {
            candidateRecords[index].isCheck = false

        }
        props.setCandidateRecords(candidateRecords);

    };
    let RemoveId = (arr, value) => {
        return arr.filter((param) => {
            return !(param[0] == value);
        });
    };
    return (
        <div>
            {/* Modal */}
            <div className="modal fade show" id="exampleModal" tabIndex={-1} style={{ "display": "block", backgroundColor: 'rgba(0,0,0,0.6)' }} aria-labelledby="exampleModalLabel" aria-hidden="true">

                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="align-items-center justify-content-inbetween">
                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <p className="font-15 tt-bold mb-0 d-flex me-3">Selected Candidates</p>
                                            </div>
                                        </div>
                                        <div>
                                            <button type="button" className="btn-close" aria-label="Close"
                                                onClick={() => {
                                                    let empIdStringi = JSON.stringify(props.empId)
                                                    let empIdCLone = JSON.parse(empIdStringi);
                                                    let removeEmp = candidateRecords.map((records) => {
                                                        if (!records.isCheck) {
                                                            let removedValues = RemoveId(empIdCLone, records.id)
                                                            empIdCLone = removedValues

                                                        }
                                                    })
                                                    props.setEmpid(empIdCLone);
                                                    let checkedRecords = candidateRecords.filter((rec) => rec.isCheck == true);
                                                    props.setCandidateRecords(checkedRecords);
                                                    if (checkedRecords.length == 0) {
                                                        setallCheck(false);
                                                        setHideBar(true)
                                                    }

                                                    props.onClose(false)
                                                }} />
                                        </div>
                                    </div>
                                    <div className="table-responsive rounded-3 recruitment-grid mt-3" style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 500 }} >
                                        <table className="table bg-white hive-grid table-borderless mb-0">
                                            <thead className="hive-table-head position-sticky" style={{ zIndex: 2 }}>
                                                <tr>
                                                    <th />
                                                    <th className="bold-text font-12">Candidate Name<span className="ps-2"></span></th>
                                                    <th className="bold-text font-12">Candidate ID<span className="ps-2"></span></th>
                                                    <th className="bold-text font-12">Email ID</th>
                                                    <th className="bold-text font-12">Contact #</th>
                                                    <th className="bold-text font-12">Resume</th>
                                                    <th className="bold-text font-12">Applied On<span className="ps-2"></span></th>
                                                    <th className="bold-text font-12">Status<span className="ps-2"></span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {gridRecord.map((candidate, index) => (
                                                    <tr key={index} className="hive-table-data regular-text align-middle">
                                                        <td className="align-items-center">
                                                            <input className="form-check-input mt-0 recruitemt-input-checkbox" type="checkbox"
                                                                id={candidate.id}
                                                                checked={candidate.isCheck ? true : false}
                                                                onChange={(e) => handleCheckboxChange(e, index)} />
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <img src={candidate.candidate_photo_url} alt="profile-img" className="table-image" />
                                                                <div className="ms-2">
                                                                    <a href="#" className="table-name-style semibold-text mb-0">{candidate.first_name + ' ' + candidate.last_name}</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{candidate.id}</td>
                                                        <td>{candidate.email_id}</td>
                                                        <td>{candidate.mobile_number}</td>
                                                        <td><a href={candidate.resume_url} className="rgrid-resume-sty mb-0 text-truncate resume-width" target="_blank">
                                                            <img src="/Images/pdf.svg" alt={candidate.resume_url} title={candidate.resume_url?.split('/').pop()} style={{ height: '20px' }} />
                                                            {/* {value.resume_url} */}
                                                        </a></td>
                                                        <td>{convertDate(candidate.created_at)}</td>
                                                        {SelectedRadio.stage == 'Screening' ? (
                                                            <td>{candidate.status == null ? 'active' : candidate.status}</td>
                                                        ) : (<td>
                                                            {candidate.status == 'Hold' || candidate.status == 'Block'
                                                                ? candidate.status
                                                                : arrStatusStore.find((status) => status.candidate_id === candidate.id)?.recommendation}
                                                        </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*popup ends here*/}
            </div>
        </div>
    )
}
export default CandidatePopupGrid